const Reflux = require('@muzzylane/reflux');

const Globals = require('../../../app/globals');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const { isArray } = require('lodash');

const ShortCourseInstanceActions = Reflux.createActions({
    createLocalShortCourseInstance: { children: ['completed', 'failed'] },
    archiveLocalShortCourseInstance: { children: ['completed', 'failed'] },
    getShortCourseInstance: { children: ['completed', 'failed'] },
    getShortCourseInstanceMinimal: { children: ['completed', 'failed'] },
    getMinimalCourseInstancesForUser: { children: ['completed', 'failed' ]},
    getCourseInstanceSummariesForUser: { children: ['completed', 'failed' ]},
    getShortCourseInstancePreviewData: { children: ['completed', 'failed' ]},
    playShortCourseInstanceContentBlock: { children: ['completed', 'failed' ]},
    authorizeLocalCourseInstanceUser:  { children: ['completed', 'failed' ]},
    authorizeLocalCourseInstanceAccessCode:  { children: ['completed', 'failed' ]},
    setShortCourseInstanceAvatar: { children: ['completed', 'failed' ]},
    setShortCourseInstanceClientState: { children: ['completed', 'failed' ]},
    setPlayViewActive: { children: ['completed', 'failed' ]},
    resetShortCourseInstanceAttempts: { children: ['completed', 'failed' ]}, // for DEMO ONLY!
    addUsersToShortCourseInstance: { children: ['completed', 'failed'] },
    setShortCourseInstanceDescInternal: { children: ['completed', 'failed'] },
    completeChatbotActivity: { children: ['completed', 'failed'] },
    addShortCourseInstanceAdmin: { children: ['completed', 'failed'] },
});

ShortCourseInstanceActions.createLocalShortCourseInstance.listen(function(actionId, params) {
    if (!params.shortCourseId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.name) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.shortCourseId}`, 'PUT', JSON.stringify({
            name: params.name,
            group_id: params.groupId,
            join_options: params.joinOptions || {},
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ShortCourseInstanceActions.archiveLocalShortCourseInstance.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}`, 'DELETE')
        .then(res => this.completed(actionId, params.instanceHash, res))
        .catch(err => this.failed(actionId, params.instanceHash, err));
});

ShortCourseInstanceActions.getShortCourseInstance.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}`, 'GET')
        .then(res => this.completed(actionId, params.instanceHash, res))
        .catch(err => this.failed(actionId, params.instanceHash, err));
});

ShortCourseInstanceActions.getShortCourseInstanceMinimal.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/minimal`, 'GET')
        .then(res => this.completed(actionId, params.instanceHash, res))
        .catch(err => this.failed(actionId, params.instanceHash, err));
});

ShortCourseInstanceActions.getShortCourseInstancePreviewData.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/preview_data`, 'GET')
        .then(res => this.completed(actionId, params.instanceHash, res))
        .catch(err => this.failed(actionId, params.instanceHash, err));
});


ShortCourseInstanceActions.getMinimalCourseInstancesForUser.listen(function(actionId) {
    ServerRequest.makeRequest(`/authoring/short_course_instances/${Globals.integration_type.LOCAL}`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ShortCourseInstanceActions.getCourseInstanceSummariesForUser.listen(function(actionId) {
    ServerRequest.makeRequest(`/authoring/short_course_instance_summaries/${Globals.integration_type.LOCAL}`, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});


ShortCourseInstanceActions.playShortCourseInstanceContentBlock.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.integrationType) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.contentBlockHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!params.nodeId) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (params.integrationType === Globals.integration_type.LOCAL || params.integrationType === Globals.integration_type.LTI) {
        ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/play/${params.nodeId}/${params.contentBlockHash}`, 'POST', JSON.stringify({}))
            .then(res => this.completed(actionId, params.instanceHash, params.contentBlockHash, res))
            .catch(err => this.failed(actionId, err));
    }
    else {
        this.failed(actionId, new ForgeError({ message: `Not Implemented for integrationType ${params.integrationType}` }));
    }

});


ShortCourseInstanceActions.authorizeLocalCourseInstanceUser.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/authorize`, 'POST', JSON.stringify({
            userProfile: params.userProfile,
        }))
        .then(res => this.completed(actionId, params.instanceHash, res))
        .catch(err => this.failed(actionId, params.instanceHash, err))
});

ShortCourseInstanceActions.authorizeLocalCourseInstanceAccessCode.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/authorize`, 'POST', JSON.stringify({
            accessCode: params.accessCode,
        }))
        .then(res => this.completed(actionId, params.instanceHash, res))
        .catch(err => this.failed(actionId, params.instanceHash, err));
});


ShortCourseInstanceActions.setShortCourseInstanceAvatar.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/avatar`, 'POST', JSON.stringify({
            avatar: params.avatar,
        }))
        .then((res) => {
            this.completed(actionId, params, res);
            if (params.successCallback) {
                params.successCallback();
            }
        })
        .catch(err => this.failed(actionId, params, err));
});

ShortCourseInstanceActions.setShortCourseInstanceClientState.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/client_state`, 'POST', JSON.stringify({
            client_state: params.client_state,
        }))
        .then((res) => {
            this.completed(actionId, params, res);
            if (params.successCallback) {
                params.successCallback();
            }
        })
        .catch(err => this.failed(actionId, params, err));
});

ShortCourseInstanceActions.setPlayViewActive.listen(function(actionId, instanceHash, active) {
    this.completed(actionId, instanceHash, active);
});

// for DEMO ONLY!!
ShortCourseInstanceActions.resetShortCourseInstanceAttempts.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (GlobalConfig.DebugMode || GlobalConfig.DevMode) {
        ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/reset_attempts`, 'POST', JSON.stringify({
            studentHash: params.studentHash
        }))
            .then((res) => {
                this.completed(actionId, params.instanceHash, res);
                if (params.successCallback) {
                    params.successCallback();
                }
            })
            .catch(err => this.failed(actionId, err));
    }
    else {
        this.failed(actionId, new ForgeError({ message: 'Not Implemented' }));
    }

});

ShortCourseInstanceActions.addUsersToShortCourseInstance.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (!isArray(params.users)) {
        this.failed(actionId, params.instanceHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/users`, 'PUT', JSON.stringify({
            users: params.users,
        }))
        .then(res => this.completed(actionId, params.instanceHash, res))
        .catch(err => this.failed(actionId, params.instanceHash, err));
});

ShortCourseInstanceActions.setShortCourseInstanceDescInternal.listen(function(actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, null, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (typeof params.description !== 'string') {
        this.failed(actionId, params.instanceHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/description_internal`, 'POST', JSON.stringify({
            description: params.description,
        }))
        .then(res => this.completed(actionId, params.instanceHash, res))
        .catch(err => this.failed(actionId, params.instanceHash, err));
});

ShortCourseInstanceActions.completeChatbotActivity.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/chatbot_complete`, 'POST', JSON.stringify({
            node_id: params.nodeId,
            content_block_hash: params.cbHash,
            attempt: params.attempt,
            scoresBySubskillHash: params.scoresBySubskillHash,
            time_played: params.time_played,
        }))
        .then((res) => {
            this.completed(actionId, params, res);
            if (params.successCallback) {
                params.successCallback();
            }
        })
        .catch(err => this.failed(actionId, params, err));
});

ShortCourseInstanceActions.addShortCourseInstanceAdmin.listen(function (actionId, params) {
    if (!params.instanceHash) {
        this.failed(actionId, params.instanceHash, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    return ServerRequest.makeRequest(`/authoring/short_course_instance/${params.instanceHash}/add_admin`, 'POST', JSON.stringify({}))
        .then((res) => this.completed(actionId, params.instanceHash, res))
        .catch((err) => this.failed(actionId, params.instanceHash, err));
});

module.exports = ShortCourseInstanceActions;